import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=69cd53bb&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=69cd53bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd53bb",
  null
  
)

export default component.exports